import gql from 'graphql-tag'

export default gql`mutation updateUser($record: UpdateByIdUserInput!){
    updateUser(record: $record) {
      recordId
    }
  }`



// WEBPACK FOOTER //
// ./src/graphql/mutations/updateUser.js